import { render } from "./ClockShow.vue?vue&type=template&id=4201d115&scoped=true"
import script from "./ClockShow.vue?vue&type=script&lang=js"
export * from "./ClockShow.vue?vue&type=script&lang=js"

import "./ClockShow.vue?vue&type=style&index=0&id=4201d115&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4201d115"]])

export default __exports__